module.exports = __webpack_public_path__ + "static/media/financial.c6504db7.svg";